import { Formatting } from "../../utils/formatting";
import { Social } from "../../utils/social";

export class OfficeDetail {
    public officeCode: string;
    public agencyManagerFirstName: string;
    public agencyManagerLastName: string;
    public agencyManagreACID: string;
    public countyName: string;
    public officeDescription: string;
    public officeAddress1: string;
    public officeAddress2: string;
    public city: string;
    public state: string;
    public zipCode: string;
    public phoneNumber: string;
    public fkSchedule: number;
    public daysOfWeek1: string;
    public hours1: string;
    public daysOfWeek2: string;
    public hours2: string;
    public longitude: number;
    public latitude: number;
    public agencyPrincipalIndicator: boolean;

    public get logoUrl(): string {
        return `/images/agency-principal-logo/${this.officeDescription.replace(/ /g, '-')}.svg`;
    }

    public get agencyUrl(): string {
        return this.agencyPrincipalIndicator ? `/offices/${this.officeDescription.replace(/ /g, '-')}` : '';
    }

    public get agencyLogoClass(): string {
        return `${this.officeDescription.replace(/ /g, '-').toLowerCase()}-logo`;
    }

    public static fromJs = (data: any): OfficeDetail => {
        const officeDetail = new OfficeDetail();
        Object.assign(officeDetail, data);
        return officeDetail;
    }
}